$(document).ready(function() {
    AOS.init({
        once: true,
    });
    $(function() {

      //$('.variations select,select.orderby,#billing_country').selectric();
      $('.variations select,select.orderby').selectric();
    });
  
    $('select.orderby').on('selectric-select', function(event, element, selectric) {
        $('form.woocommerce-ordering').submit();
    });

    $('select#pa_velikost, select#pa_barva').on('selectric-select', function(event, element, selectric) {

        var barva    = $('select#pa_barva').val();
        var velikost = $('select#pa_velikost').val();

        var obj = jQuery.parseJSON($('.variations_form').attr('data-product_variations'));
        $('#woocommerce-variation-availability').html('');        
        
        $.each(obj, function(i, item) {
            if($('select#pa_barva').length && $('select#pa_velikost').length){
                if(obj[i].attributes.attribute_pa_velikost === velikost && obj[i].attributes.attribute_pa_barva === barva){
                    count = $('.single_variation_wrap .single_variation .woocommerce-variation-availability').length;
                    if(count == 0){
                        $( ".single_variation_wrap .single_variation" ).append( '<div class="woocommerce-variation-availability"></div>' );
                    }
                    ava = obj[i].availability_html;
                    if(ava != ''){
                        $('.single_variation_wrap .woocommerce-variation-availability').html(ava);
                    }else{
                        $('.single_variation_wrap .woocommerce-variation-availability').html('');
                    }
                
                    if(obj[i].image.full_src != ''){
                        $('.varitation-img').html('<img src="'+obj[i].image.src+'" class="lazy img-responsive" />').show();
                        $('.product-img').hide();
                    }
                
                    $('#variation_id').attr('value',obj[i].variation_id);
                    $('button.single_add_to_cart_button.disabled').removeClass('disabled');
                }
            }else if(!$('select#pa_barva').length && $('select#pa_velikost').length && obj[i].attributes.attribute_pa_velikost == ''){
               
                //if(obj[i].attributes.attribute_pa_velikost === velikost){
                    count = $('.single_variation_wrap .single_variation .woocommerce-variation-availability').length;
                    if(count == 0){
                        $( ".single_variation_wrap .single_variation" ).append( '<div class="woocommerce-variation-availability"></div>' );
                    }
                    ava = obj[i].availability_html;
                    if(ava != ''){
                        $('.single_variation_wrap .woocommerce-variation-availability').html(ava);
                    }else{
                        $('.single_variation_wrap .woocommerce-variation-availability').html('');
                    }
                    
                    if(obj[i].image.full_src != ''){
                        $('.varitation-img').html('<img src="'+obj[i].image.src+'" class="lazy img-responsive" />').show();
                        $('.product-img').hide();
                    }
                    $('#variation_id').attr('value',obj[i].variation_id);
                    $('button.single_add_to_cart_button.disabled').removeClass('disabled');
                //}
            }
        });
        $(this).trigger('change');
        $('.variations select').data('selectric').refresh();
     });

     $('select#pa_barva').on('selectric-select', function(event, element, selectric) {

         var myarray = [];

         var barva    = $('select#pa_barva').val();
         var obj = jQuery.parseJSON($('.variations_form').attr('data-product_variations'));
         $.each(obj, function(i, item) {
             if(obj[i].attributes.attribute_pa_barva === barva){
                 myarray.push(obj[i].attributes.attribute_pa_velikost);
             }
         });
         $("#pa_velikost option").remove();
         $("#pa_velikost").append('<option value="">Zvolte velikost</option>');
         $.each(myarray, function(i, item) {
             $("#pa_velikost").append('<option value="'+myarray[i]+'">' + myarray[i].toUpperCase() + '</option>');
         });
         $('select').selectric('init');
         /*

         */
     })

     $("#ship-to-different-address-checkbox,#ship-to-different-address-checkbox,#createaccount").on('ifChanged', function(event){
         $('.'+$(this).attr('data-target')).toggle( );
     });

    $('.lazy').lazy({
      effect: "fadeIn",
      effectTime: 500,
      threshold: 0
    });

    $("#addToCart a.close").click(function(){
        $('#addToCart').removeClass('active').addClass('closed');
    });

    $("a.smartsuplink").click(function(){
        smartsupp('chat:open');
    });


    $(".jsLink").click(function(){
         window.location=$(this).find("a").attr("href");
         return false;
    });

    $('.photo,.blocks-gallery-item a').magnificPopup({
        type: 'image',
        closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: function(item) {
				return "";
			}
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });

    $('a.video').magnificPopup({
          type: 'iframe',
    });

    $('input[type="checkbox"]:not(.c-tgl)').iCheck({
      checkboxClass: 'icheckbox_square',
      radioClass: 'iradio_square',
      increaseArea: '20%' // optional
    });

    $(".modal-btn").click(function(){
        $($(this).attr('data-target')).addClass('active');
        $('#loginForm .forms-login').removeClass('active');
        $('#customer_login').addClass('active');
    })

    $('a.close-modal').click(function(){
        $(this).closest('.modaler').removeClass('active');
    })

    $(".login-modal-btn").click(function(){
        $('#loginForm .forms-login').removeClass('active');
        $($(this).attr('data-target')).addClass('active');
    })


    $(".btn-checkout").click(function(){
        step = $(this).attr('data-target');
        if(step == 2){
            bool = false;
            /*
            val  = $('#zasilkovna_id_zas').length;
            bool = false;

            if(val == 1){
                v = $('#zasilkovna_id_zas').val();
                if(v === 'default'){
                    alert('Zvolte prosím výdejní místo');
                    bool = true;
                }
            }
            */
            if(bool == false){
                    $('.step').removeClass('active');
                    $('#step-1').addClass('active');
                    $('.infos-check-in').hide();
                    $('.infos-check-out').css('display','block');

                    $('.cartstep li.is-active').removeClass('is-active');
                    $('.cartstep li:eq( 2 )').addClass('is-active');
                    $('.cartstep li:eq( 2 )').addClass('active');

                    $('html, body').animate({
                        scrollTop: $("#step-1").offset().top
                    }, 1000);
            }
        }
        if(step == 1){
            $('.cartstep li.is-active').removeClass('is-active');
            $('.cartstep li:eq( 2 )').removeClass('active');
            $('.cartstep li:eq( 1 )').addClass('is-active');
            $('.step').removeClass('active');
            $('#customer_details').addClass('active');
            $('.infos-check-out').hide();
            $('.infos-check-in').css('display','block');
            $('html, body').animate({
                scrollTop: $("#customer_details").offset().top
            }, 1000);
        }
    });


    $(function() {
        var $el = $('.parallax-background');
        if($( window ).width() < 575 ){
            w = '50%';
            scroll += $('.parallax-background').height() - 300;
            $el.css({
                'background-position':w+' '+(+.4*scroll)+'px'
            });
        }
        $(window).on('scroll', function () {
            w = '100%';
            if($( window ).width() < 992 ){
                w = '20%';
            }

            var scroll = $(document).scrollTop();
            if($( window ).width() < 575 ){
                w = '100%';
                //alert();
                scroll += $('.parallax-background').height() - 300;
            }
            $el.css({
                'background-position':w+' '+(+.4*scroll)+'px'
            });
        });
    });

    $( ".setstars i" )
     .mouseover(function() {
         val = $(this).attr('data-val');
         $( ".setstars i" ).each(function( index ) {
             if(index < val){
                 $(this).addClass('active');
             }else{
                 $(this).removeClass('active');
             }
        });
      })
     .mouseout(function() {
         val = $('input[name="rating"]').val();
         $( ".setstars i" ).each(function( index ) {
             if(index < val){
                 $(this).addClass('active');
             }else{
                 $(this).removeClass('active');
             }
        });
     });

     $(".setstars i").click(function(){

         val = $(this).attr('data-val');
         $('input[name="rating"]').val(val);

         $( ".setstars i" ).each(function( index ) {
             if(index < val){
                 $(this).addClass('active');
             }else{
                 $(this).removeClass('active');
             }
        });
     });

});

function setVaritation(v){

    var checkedVaritation = v;

    var form = $('form.variations_form.cart').attr('data-product_variations');
    form = JSON.parse(form);

    var actual = form[checkedVaritation];
    $('#max-quantity').html(actual.max_qty + " osob");

    var actualDate = dates[v];
    var date = actualDate.split(" - ");

    $('#datum-start').html(date[0]);
    $('#datum-end').html(date[1]);
    $('button.disabled').removeClass('disabled');
    console.log(actual.variation_id);
    $('#variation_ids').attr('value',actual.variation_id);
}
